import {
  useChannelTemplates,
  useChannelType,
  useSendCommunication,
} from "@features/cx/services/hooks";
import { CommunicationDialog } from "@features/cx/shared/components/CommunicationDialog";
import { Button } from "@shared/ui/button";
import { Phone, Send } from "lucide-react";
import { useState } from "react";
import { RequestCommunicationsLandingTab } from "./communicationTab";

export function RequestCommunications({
  remoteUtilityId,
  email,
  phone,
  entityId,
  action,
}: {
  remoteUtilityId: number;
  email: string;
  phone: string;
  entityId: string;
  action: string;
}) {
  const [communicationDialogOpen, setCommunicationDialogOpen] = useState(false);

  const handleSendMessage = () => {
    setCommunicationDialogOpen(true);
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">Communication History</h2>
        <div className="flex gap-2">
          {action === "send" && (
            <Button
              size="sm"
              className="flex items-center gap-1"
              onClick={handleSendMessage}
            >
              <Send className="h-4 w-4" />
              Send Message
            </Button>
          )}
          <Button
            size="sm"
            className="flex items-center gap-1"
            onClick={handleSendMessage}
          >
            <Send className="h-4 w-4" />
            Send Message
          </Button>
        </div>
      </div>

      <CommunicationDialog
        isOpen={communicationDialogOpen}
        onClose={() => setCommunicationDialogOpen(false)}
        consumerId={entityId}
        remoteUtilityId={remoteUtilityId}
        email={email}
        phone={phone}
        useChannelType={useChannelType}
        useChannelTemplates={useChannelTemplates}
        useSendCommunication={useSendCommunication}
        communicationType={action}
      />

      <RequestCommunicationsLandingTab
        entityId={entityId}
        type="all"
        remoteUtilityId={Number(remoteUtilityId)}
        action={action}
      />
    </div>
  );
}
